import Marquee from "react-fast-marquee";

const PHRASES = [
  "Consciousness as Generative Field",
  "Piezoelectric Granite",
  "Archaeoacoustics",
  "Plasma & Veil-Thinners",
  "Magnetite Receivers",
  "Resonant Chambers",
  "UAP / NHI Interaction",
];

export const EditorialMarquee = () => (
  <div className="relative border-y border-white/10 bg-[#0B0D17]/40 py-8" data-testid="marquee">
    <Marquee speed={28} gradient gradientColor="#05060A" gradientWidth={120}>
      {PHRASES.map((p, i) => (
        <span key={i} className="mx-10 inline-flex items-center gap-10">
          <span className="font-display text-3xl md:text-4xl italic font-light text-white/30">{p}</span>
          <span className="h-1.5 w-1.5 rounded-full bg-plasma-teal/40" />
        </span>
      ))}
    </Marquee>
  </div>
);
